/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット画面状態管理
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import VueCookie from 'vue-cookie'

export default new class {
  /**
   * クッキーのオプション値を取得します。
   */
  getCookieOption() {
    return {
      path: window.location.pathname.replace(new RegExp('/index.html$'), ''),
      secure: (document.location.protocol === 'https:')
    }
  }

  /**
   * チャット画面状態があるか
   * @return {Boolean} [description]
   */
  existsFastchatState() {
    return VueCookie.get('FastchatState') != null
  }
  /**
   * チャット開始済みか
   * @return {Boolean} [description]
   */
  isStarted() {
    return VueCookie.get('FastchatState') === 'started'
  }
  /**
   * チャット開始済みにする
   */
  changeStarted() {
    VueCookie.set('FastchatState', 'started', this.getCookieOption())
  }

  /**
   * 保留中か
   * @return {Boolean} [description]
   */
  isSuspended() {
    return VueCookie.get('FastchatState') === 'suspended'
  }
  /**
   * 保留中にする
   */
  changeSuspended() {
    VueCookie.set('FastchatState', 'suspended', this.getCookieOption())
  }

  /**
   * 保留中（新着メッセージあり）か
   * @return {Boolean} [description]
   */
  isSuspendedWithNewNoticed() {
    return VueCookie.get('FastchatState') === 'suspendedWithNewNoticed'
  }
  /**
   * 保留中（新着メッセージあり）にする
   */
  changeSuspendedWithNewNoticed() {
    VueCookie.set('FastchatState', 'suspendedWithNewNoticed', this.getCookieOption())
  }

  /**
   * チャット終了済みか
   * @return {Boolean} [description]
   */
  isEnded() {
    return VueCookie.get('FastchatState') === 'ended'
  }
  /**
   * チャット終了済みにする
   */
  changeEnded() {
    VueCookie.set('FastchatState', 'ended', this.getCookieOption())
  }
  /**
   * チャット中か
   * @return {Boolean} [description]
   */
  isChatting() {
    return this.existsFastchatState() && !this.isEnded()
  }

  /**
   * 最新の新着メッセージのSNSメッセージ番号を設定します
   * @param {Numer} snsMessageId
   */
  setLastNewFhMessageSnsMessageId(snsMessageId) {
    VueCookie.set('LastNewFhMessageSnsMessageId', snsMessageId, this.getCookieOption())
  }
  /**
   * 最新の新着メッセージのSNSメッセージ番号をクリアします
   * @param {Numer} snsMessageId
   */
  clearLastNewFhMessageSnsMessageId() {
    VueCookie.delete('LastNewFhMessageSnsMessageId', this.getCookieOption())
  }
  /**
   * 最新の新着メッセージのSNSメッセージ番号を取得します
   */
  getLastNewFhMessageSnsMessageId() {
    let lastNewFhMessageSnsMessageId = VueCookie.get('LastNewFhMessageSnsMessageId')
    if (lastNewFhMessageSnsMessageId != null && lastNewFhMessageSnsMessageId.length > 0) {
      return Number(lastNewFhMessageSnsMessageId)
    }
    return null
  }

  /**
   * 別ウィンドウモードである事を設定します。
   */
  setAlwaysSeparateChatWindow() {
    VueCookie.set('AlwaysSeparateChatWindow', 'true', this.getCookieOption())
  }

  /**
   * 別ウィンドウモードか
   */
  isAlwaysSeparateChatWindow() {
    return VueCookie.get('AlwaysSeparateChatWindow') === 'true'
  }

  /**
   * アンケート済みを設定します
   */
  setOpendSurvey() {
    VueCookie.set('OpenedSurvey', 'true', this.getCookieOption())
  }
  /**
   * アンケート済みをクリアします
   */
  clearOpenedSurvey() {
    VueCookie.delete('OpenedSurvey', this.getCookieOption())
  }
  /**
   * アンケート済みか
   */
  isOpenedSurvey() {
    let openedSurvey = VueCookie.get('OpenedSurvey')
    return openedSurvey === 'true'
  }

  /**
   * FastChat状態を取得します
   */
  getFastchatState() {
    return VueCookie.get('FastchatState')
  }
}()



// WEBPACK FOOTER //
// ./src/utils/FastchatStateManager.js